module.exports = {
  signalProcessing: require('./signalProcessing'),
  parseTree: require('./parseTree'),
  Keyboard: require("./Keyboard"),
  treeHelper: require('./treeHelper'),
  colorLib: require('./colorLib'),
  apexDownload: require('./apexDownload'),
  apexTimeDownload: require('./apexTimeDownload'),
  preferences: require('./preferences'),
  passwordCheck: require("./passwordCheck")
}
